import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/plugins/fontawesome/css/fontawesome.min.css";
import "./assets/plugins/fontawesome-free-6.5.2-web/css/all.min.css";
import "./assets/css/style.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/@iconscout/unicons/css/line.css";
import reportWebVitals from "./reportWebVitals";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import "primereact/resources/primereact.min.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import Whatsapp from "./components/whatsapp";
import Loader from "./components/loader";
import Cookie from "./components/cookie/cookie";
import "./assets/icons/tabler-icons/webfont/tabler-icons.css";
import TagManager from "react-gtm-module";
import { LOCAL_API_BASE_URL } from "./config";

const rootElement = document.getElementById("root") as HTMLElement;

const addGoogleSiteVerification = (verificationCode: string) => {
  const selector = 'meta[name="google-site-verification"]';
  const existingTag = document.querySelector(selector);

  if (existingTag) {
    existingTag.setAttribute("content", verificationCode);
    return;
  }

  const meta = document.createElement("meta");
  meta.name = "google-site-verification";
  meta.content = verificationCode;
  document.head.appendChild(meta);
};

const loadGtagScript = (measurementId: string) => {
  const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  if (document.querySelector(`script[src="${scriptSrc}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.src = scriptSrc;
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", measurementId);
  };
};

// Function to dynamically load the Google Analytics script
const loadGAScript = () => {
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=G-VBH47P9RCF`;
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", "G-VBH47P9RCF");
  };
};
const loadGAScriptTOC = (measurementId: string) => {
  loadGtagScript(measurementId);
};
const loadGAScriptPrime = (measurementId: string) => {
  loadGtagScript(measurementId);
};
const loadGAScriptBL = () => {
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=GTM-PD5VHQN`;
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", "GTM-PD5VHQN");
  };
};

const loadGAScriptXCEL = () => {
  const measurementId = "G-FS1PHBXHJ3";
  const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

  if (document.querySelector(`script[src="${scriptSrc}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.src = scriptSrc;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag("js", new Date());
  gtag("config", measurementId);
};

const loadMetaPixelXCEL = () => {
  const w = window as Window & { fbq?: (...args: unknown[]) => void };
  if (w.fbq) return;

  const script = document.createElement("script");
  script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1550054962747365');
fbq('track', 'PageView');`;
  document.head.appendChild(script);

  if (!document.getElementById("meta-pixel-xcel-noscript")) {
    const noscript = document.createElement("noscript");
    noscript.id = "meta-pixel-xcel-noscript";
    noscript.innerHTML =
      '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1550054962747365&ev=PageView&noscript=1" alt="" />';
    document.body.insertBefore(noscript, document.body.firstChild);
  }
};

// Function to load Google Tag Manager for a given GTM container ID
const loadGTM = (gtmId: string) => {
  // Check if GTM script is already loaded
  if (document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`)) {
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];

  // Add GTM script to head
  const script = document.createElement('script');
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.appendChild(script);

  // Add noscript iframe to body
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
};

// Function to load the AnyChat chatbot script
const loadAnyChatScript = () => {
  const scriptId = 'contactus-jssdk';
  
  // Check if script is already loaded
  if (document.getElementById(scriptId)) {
    return;
  }

  const d = document;
  const s = 'script';
  const js = d.createElement(s) as HTMLScriptElement;
  const fjs = d.getElementsByTagName(s)[0];
  
  js.id = scriptId;
  js.src = 'https://api.anychat.one/widget/01eb58af-42b8-348e-b642-163055853da5?r=' + encodeURIComponent(window.location.href);
  
  if (fjs && fjs.parentNode) {
    fjs.parentNode.insertBefore(js, fjs);
  } else {
    d.head.appendChild(js);
  }

  // Add CSS to ensure WhatsApp button appears above chatbot
  const styleId = 'whatsapp-chatbot-zindex';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      /* Ensure WhatsApp button appears above chatbot widget */
      .link-whatsapp {
        z-index: 10000 !important;
        bottom: 100px !important;
        right: 20px !important;
      }
      /* Ensure chatbot widget has lower z-index */
      [id*="anychat"], [id*="contactus"], iframe[src*="anychat"] {
        z-index: 9999 !important;
      }
    `;
    document.head.appendChild(style);
  }
};

// Check the current URL against the allowed URL from environment variables
if (window.location.href.includes("laundryup.co.uk")) {
  loadGAScript();
} else if (window.location.href.includes("bestatlaundry.com")) {
  loadGAScriptBL();
} else if (window.location.href.includes("primedrycleaners")) {
  loadGAScriptPrime("G-LJL7V02J0X");
  addGoogleSiteVerification("k42JI12XGkMcBU4RX0g9-7hrZekCgdNib4REPElPWNI");
} else if (window.location.href.includes("touchofclassdrycleaner")) {
  loadGAScriptTOC("G-FS1PHBXHJ3");
  addGoogleSiteVerification("MMG9Vd0fUWz9CB65C56e9kTyY-kQFII7kExyuPoOOJg");
  loadGTM("GTM-M8DBKHJZ");
} else if (window.location.href.includes("laundrydeluxe.uk")) {
  loadGTM("GTM-52HXWB4X");
  loadGtagScript("G-PBNC7KQ54V");
  addGoogleSiteVerification("g6QdMUVHEnxbnMe9tPUH6yYNhOUo1KsUXmx9SWCuItw");
}

if (
  window.location.hostname === "localhost" &&
  LOCAL_API_BASE_URL.includes("touchofclassdrycleaner.com")
) {
  loadGAScriptTOC("G-GQN2MHGDES");
  addGoogleSiteVerification("iwENesy6dIXlZAooZmbix1k-DjTS507SzpjihAdWPvU");
}

if (
  window.location.hostname === "localhost" &&
  LOCAL_API_BASE_URL.includes("primedrycleaners.uk")
) {
  loadGAScriptPrime("G-LJL7V02J0X");
  addGoogleSiteVerification("k42JI12XGkMcBU4RX0g9-7hrZekCgdNib4REPElPWNI");
}

// Load AnyChat chatbot script if URL contains 'xceldrycleaners'
if (window.location.href.includes('xceldrycleaners')) {
  loadAnyChatScript();
  loadGAScriptXCEL();
  loadMetaPixelXCEL();
  addGoogleSiteVerification("x4grheIxi9g3u2Bw22_D1sakaxoBzMMLXzErj26JuwY");
}

const appTree = (
  <Provider store={store}>
    <BrowserRouter>
      <Loader />
      <App />
      <Cookie />
      <Whatsapp />
    </BrowserRouter>
  </Provider>
);

// react-snap snapshots are SEO-only; always mount fresh so no tenant sees
// stale pre-rendered content from a different tenant's build.
ReactDOM.createRoot(rootElement).render(appTree);
reportWebVitals();
